import $ from 'jquery';
import '../vendor/scrolloverflow';
import fullpage from 'fullpage.js';

class FullpageScroller {
	constructor(els) {
		this.container = $(els);

		if($(window).width() < 768) {
			$('#fullpage').removeAttr('id');
		} else {
			this.createScroller();
		}
	}

	createScroller() {
		const that = this;

		this.container.fullpage({
			navigation: true,
			navigationPosition: 'left',
            css3: true,
            scrollBar: true,
            hybrid: true,
            controlArrows: true,
            verticalCentered: true,
            fitToSection: true
		});
	}
}

export default FullpageScroller;



// WEBPACK FOOTER //
// ./src/js/modules/fullpageScroller.js